'use client';
import * as React from 'react';

export const DrawerPositionContext = React.createContext<'left' | 'right' | undefined>(undefined);
